import React, { useState, useEffect, useRef } from "react";

import fondJeu from "assets/puzzles/iserba/roadSafety/interieur_voiture.svg";
import deuxiemePersonnage from "assets/puzzles/iserba/roadSafety/deuxieme_personnage.svg";
import interfaceGpsActive from "assets/puzzles/iserba/roadSafety/interface_gps_active.svg";
import IserbaAvatarViewer from "components/onboarding/iserba/IserbaAvatarViewer";
import CumulatedScore from "components/quiz/CumulatedScore";
import TypewriterText from "components/shared/TypeWriterText";

const Game2RadioQuiz = ({
	quiz,
	question,
	onAnswer,
	quizResults,
	setQuizResults,
	handleNext,
}) => {
	const gridRef = useRef(null);
	const [gridSize, setGridSize] = useState(0);
	const [selectedOption, setSelectedOption] = useState(null);
	const [showResult, setShowResult] = useState(false);
	const [showOptions, setShowOptions] = useState(false);

	const storedPlayer = localStorage.getItem("player");
	let player = storedPlayer ? JSON.parse(storedPlayer) : null;

	useEffect(() => {
		setShowResult(false);
		setSelectedOption(null);
		setShowOptions(false);
	}, [question]);

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	const submitAnswer = () => {
		if (selectedOption !== null) {
			onAnswer(selectedOption);
			setShowResult(true);
		}
	};

	const getHeaderText = () => {
		return "Répondez correctement aux questions.";
	};

	return (
		<div className="relative flex flex-col items-center h-full mt-4">
			<div className="px-4 flex flex-1 justify-between items-end gap-2">
				<div className="flex flex-col text-white">
					<IserbaAvatarViewer player={player} />
					<h3 className="text-sm text-gray-700 py-2 px-4 shadow-md mb-2 bg-white rounded-full">
						{getHeaderText()}
					</h3>
				</div>

				{quiz?.config?.show_cumulated_score && (
					<div className="flex py-2 px-1">
						<CumulatedScore quizId={quiz.id} quizResults={quizResults} />
					</div>
				)}
			</div>

			<div className="flex-[3] flex justify-center items-start">
				<div className="relative flex flex-col items-start non-selectable">
					<div
						ref={gridRef}
						className={`relative grid gap-0 m-auto w-full aspect-square border-black border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)]`}
						style={{
							width: gridSize,
							height: gridSize,
							backgroundImage: fondJeu ? `url(${fondJeu})` : "none",
							backgroundSize: "cover",
						}}
					>
						<img
							src={deuxiemePersonnage}
							alt="deuxiemePersonnage"
							className="absolute bottom-0 right-0 w-full"
						/>
						<img
							src={interfaceGpsActive}
							alt="interfaceGpsActive"
							className="absolute bottom-0 right-0 w-full"
						/>
						{showResult ? (
							<div
								className={`absolute bottom-8 right-4 left-4 py-2 px-4 shadow-md bg-white rounded-3xl text-center text-sm text-gray-700`}
							>
								<p>
									La bonne réponse est... :{" "}
									{question.options.find((opt) => opt.isCorrect)?.label}
								</p>
								<p
									className={
										selectedOption ===
										question.options.find((opt) => opt.isCorrect)?.value
											? "text-green-600 font-bold"
											: "text-red-600 font-bold"
									}
								>
									{selectedOption ===
									question.options.find((opt) => opt.isCorrect)?.value
										? "Félicitations !"
										: "Dommage !"}
								</p>
								<p className="mt-2 ">{question.explanation}</p>
							</div>
						) : (
							<>
								<div className="absolute inset-0 left-1/2 transform -translate-x-1/2  flex items-center justify-center bg-transparent">
									{/* Expanding sound waves */}
									<div className="absolute w-24 h-24 bg-gray-700 rounded-full opacity-30 animate-ping"></div>
									<div className="absolute w-16 h-16 bg-gray-600 rounded-full opacity-40 animate-ping delay-150"></div>

									<h3 className="absolute bottom-1/3 py-2 px-2 shadow-lg bg-white rounded-3xl text-center text-sm text-gray-700">
										<span className="font-bold">Radio: </span>
										<TypewriterText
											text={question.text}
											onFinish={() => setShowOptions(true)}
										/>
									</h3>
								</div>

								{showOptions && (
									<div className="absolute bottom-8 right-4 left-4 ">
										<div className={`flex justify-around text-sm gap-2 `}>
											{question.options.map((option, index) => (
												<button
													key={index}
													onClick={() => setSelectedOption(option.value)}
													className={`flex-1 block text-sm text-gray-700 text-center py-2 px-1 border rounded-3xl transition-all duration-150 active:translate-y-1
                            ${
															selectedOption === option.value
																? "border-black text-white bg-[#ffc574] shadow-[6px_6px_0px_rgba(0,0,0,0.7)]"
																: "border-gray-300 text-gray-700 bg-white shadow-[6px_6px_0px_rgba(0,0,0,0.5)]"
														}
                          `}
												>
													{option.label}
												</button>
											))}
										</div>
									</div>
								)}
							</>
						)}
					</div>

					<div className="mt-4 h-24 px-4 mb-8 flex w-full justify-end items-center gap-0">
						{showResult ? (
							<button
								onClick={handleNext}
								className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
							>
								Continuer
							</button>
						) : (
							<button
								onClick={submitAnswer}
								className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
							>
								Continuer
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Game2RadioQuiz;
